export const BaterMaoModalIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="4" width="48" height="48" rx="24" fill="#D5DEFF" />
    <rect
      x="4"
      y="4"
      width="48"
      height="48"
      rx="24"
      stroke="#EAEFFF"
      strokeWidth="8"
    />
    <path
      d="M19.7125 25.9113C20.44 25.4978 21.3489 25.8044 21.7427 26.5525L23.6823 30.5092C23.7187 30.5841 23.7822 30.6424 23.8599 30.6723C23.9376 30.7021 24.0238 30.7013 24.1009 30.67C24.1621 30.6457 24.2145 30.6035 24.2513 30.549C24.2882 30.4945 24.3078 30.4302 24.3077 30.3644V19.375C24.3077 18.723 24.91 18.25 25.5625 18.25C26.215 18.25 26.7813 18.723 26.7813 19.375V26.7175C26.7797 26.8546 26.8316 26.987 26.9261 27.0864C27.0205 27.1858 27.15 27.2445 27.287 27.25C27.3556 27.2513 27.4237 27.2389 27.4874 27.2136C27.5511 27.1883 27.6091 27.1505 27.658 27.1025C27.7069 27.0545 27.7458 26.9972 27.7723 26.934C27.7989 26.8708 27.8125 26.8029 27.8125 26.7344V17.125C27.8125 16.473 28.3253 16 28.9778 16C29.6303 16 30.1563 16.473 30.1563 17.125V26.7175C30.1547 26.8546 30.2066 26.987 30.3011 27.0864C30.3955 27.1858 30.525 27.2445 30.662 27.25C30.7306 27.2513 30.7987 27.2389 30.8624 27.2136C30.9261 27.1883 30.9841 27.1505 31.033 27.1025C31.0819 27.0545 31.1208 26.9972 31.1473 26.934C31.1739 26.8708 31.1875 26.8029 31.1875 26.7344V18.625C31.1875 17.973 31.7538 17.5 32.4063 17.5C33.0588 17.5 33.625 18.0198 33.625 18.6719V27.4675C33.6234 27.6046 33.6754 27.737 33.7698 27.8364C33.8643 27.9358 33.9938 27.9945 34.1308 28C34.1993 28.0013 34.2674 27.9889 34.3311 27.9636C34.3948 27.9383 34.4528 27.9005 34.5018 27.8525C34.5507 27.8045 34.5896 27.7472 34.6161 27.684C34.6426 27.6208 34.6563 27.5529 34.6563 27.4844V21.625C34.6563 20.973 35.1756 20.5 35.8281 20.5C36.4806 20.5 37.0056 20.9791 37 21.625V31.75C37 37.2536 33.625 40 29.5 40H28.75C24.625 40 23.3261 38.1437 22.375 35.875L19.1561 27.9531C18.8439 27.1094 18.9855 26.3242 19.7125 25.9113Z"
      fill="#819DFF"
    />
  </svg>
);
